import React, { useEffect, useState } from "react";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

import {
  Button,
  Card,
  Col,
  Form,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import FormInput from "./FormInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalStyles from "../../util/styles";
import TooltipIcon from "../TooltipIcon";
import AddSurflineSource from "./AddSurflineSource";
import { useMutationHandler, useCreateMutation } from "../../hooks/mutations";
import { useCreateToast } from "../../hooks/toasts";
import api from "../../api/API";
const styles = {
  ...globalStyles,
  section: {
    marginTop: "1.5em",
  },
};
const SpotCreateForm = () => {
  let history = useHistory();
  const createToast = useCreateToast();
  const methods = useForm();
  const [showModal, setShowModal] = useState(false);
  const toggleModal = () => setShowModal((prev) => !prev);
  const [swellSources, setSwellSources] = useState([]);
  const [tideSources, setTideSources] = useState([]);

  const [modalType, setModalType] = useState("");

  const showSwellModal = () => {
    setModalType("swell");
    setShowModal(true);
  };
  const showTideModal = () => {
    setModalType("tide");
    setShowModal(true);
  };

  const addSwellSource = (src) => {
    toggleModal();
    const formattedSource = { category: "swell", ...src };
    setSwellSources((prev) => [...prev, formattedSource]);
  };

  const removeSwellSource = (source) => {
    setSwellSources((srcs) => srcs.filter((src) => src.id !== source.uniqueId));
  };
  const addTideSource = (src) => {
    toggleModal();
    const formattedSource = { category: "tide", ...src };
    setTideSources((prev) => [...prev, formattedSource]);
  };
  const removeTideSource = (source) => {
    setTideSources((srcs) => srcs.filter((src) => src.id !== source.uniqueId));
  };

  const getModalTitle = (modalType) => {
    switch (modalType) {
      case "swell":
        return "Add Swell Source";
      case "tide":
        return "Add Tide Source";
      default:
        return "Something went wrong";
    }
  };
  const createSpot = useCreateMutation(api.spots);
  const successCallback = (data) => {
    createToast("success", `${data.spot.name} successfully created`);
    history.push("/spots");
  };
  const errorCallback = (data) => {
    // toggle();
    createToast("error", "Error creating Spot");
  };
  const mutationHandler = useMutationHandler(
    ["spots"],
    createSpot,
    successCallback,
    errorCallback
  );
  methods.register("dataSourcesAttributes", { required: true });
  useEffect(() => {
    methods.setValue("dataSourcesAttributes", [
      ...tideSources,
      ...swellSources,
    ]);
  }, [tideSources, swellSources, methods]);

  return (
    <>
      <Row className="mt-5">
        <Col xs={12} md={8} className="mx-auto">
          <Card body className="spot-form-card">
            <FormProvider {...methods}>
              <Form onSubmit={methods.handleSubmit(mutationHandler)}>
                <Row noGutters>
                  <Col xs="auto">
                    <h3>Spot Details</h3>
                  </Col>
                  <Col xs={12}>
                    <FormInput
                      label="Spot Name"
                      name="name"
                      type="text"
                      required
                    />
                  </Col>
                </Row>
                <Row noGutters>
                  <Col xs={12}>
                    <FormInput
                      label="Description"
                      name="description"
                      type="textarea"
                      required
                    />
                  </Col>
                </Row>
                <Row noGutters style={styles.section}>
                  <Col xs="auto">
                    <h3>Swell Sources</h3>
                  </Col>
                  <Col xs="auto" className="ml-1">
                    <TooltipIcon message="Swell sources determine where swell data is fetched from" />
                  </Col>
                  <Col xs="auto" className="ml-auto">
                    <Button color="primary" size="sm" onClick={showSwellModal}>
                      <FontAwesomeIcon icon={faPlus} size="xs" />
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <Table responsive borderless style={styles.table}>
                      <thead style={styles.tableBorder}>
                        <tr>
                          <th>Name</th>
                          <th>Vendor</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody className="bg-light" style={styles.tableBorder}>
                        {swellSources?.map((swellSource, ndx) => (
                          <tr key={ndx}>
                            <td>{swellSource.name}</td>
                            <td>{swellSource.vendor}</td>
                            <td className="text-right">
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => removeSwellSource(swellSource)}
                              >
                                <FontAwesomeIcon icon={faTrash} size="xs" />
                              </Button>
                            </td>
                          </tr>
                        ))}
                        {swellSources?.length === 0 && (
                          <tr>
                            <td className="text-center" colSpan="3">
                              No Sources Added
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Row noGutters style={styles.section}>
                  <Col xs="auto">
                    <h3>Tide Sources</h3>
                  </Col>
                  <Col xs="auto" className="ml-1">
                    <TooltipIcon message="Tide sources determine where tide data is fetched from" />
                  </Col>
                  <Col xs="auto" className="ml-auto">
                    <Button color="primary" size="sm" onClick={showTideModal}>
                      <FontAwesomeIcon icon={faPlus} size="xs" />
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <Table responsive borderless style={styles.table}>
                      <thead style={styles.tableBorder}>
                        <tr>
                          <th>Name</th>
                          <th>Vendor</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody className="bg-light" style={styles.tableBorder}>
                        {tideSources?.map((tideSource, ndx) => (
                          <tr key={ndx}>
                            <td>{tideSource.name}</td>
                            <td>{tideSource.vendor}</td>
                            <td className="text-right">
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => removeTideSource(tideSource)}
                              >
                                <FontAwesomeIcon icon={faTrash} size="xs" />
                              </Button>
                            </td>
                          </tr>
                        ))}
                        {tideSources?.length === 0 && (
                          <tr>
                            <td className="text-center" colSpan="3">
                              No Sources Added
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </Col>
                </Row>
                <Row noGutters style={styles.section}>
                  <Col xs="auto" className="ml-auto">
                    <Button color="primary">Submit</Button>
                  </Col>
                  <Col xs="auto">
                    <Button color="link">Cancel</Button>
                  </Col>
                </Row>
              </Form>
            </FormProvider>
          </Card>
        </Col>
      </Row>
      <Modal
        autoFocus={false}
        centered
        size="lg"
        isOpen={showModal}
        toggle={toggleModal}
      >
        <ModalHeader className="border-bottom-0">
          <strong>{getModalTitle(modalType)}</strong>
        </ModalHeader>
        <ModalBody>
          {modalType === "swell" ? (
            <AddSurflineSource
              onSelect={addSwellSource}
              onCancel={toggleModal}
            />
          ) : (
            <AddSurflineSource
              onSelect={addTideSource}
              onCancel={toggleModal}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default SpotCreateForm;
